import styles from "./ContinueAssessmentsBar.module.css";

export default function CheckInAssessmentSticker(props: { bgColor?: string }) {
  return (
    <div
      style={props.bgColor ? { backgroundColor: props.bgColor } : {}}
      className={styles.mainSticker}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5741 1.04172L13.7652 5.03995C13.8416 5.29647 13.5698 5.52864 13.3199 5.39122L11.8764 4.6126L8.91601 10.3486C8.83341 10.5013 8.64854 10.5564 8.49318 10.4745L5.71249 8.97036L3.28625 12.9331L0.994633 11.6934L4.51411 5.71397C4.59671 5.56127 4.78157 5.5062 4.93694 5.588L7.71498 7.09298L9.58674 3.37361L8.14242 2.59232C7.89213 2.45693 7.93622 2.10382 8.19274 2.0274L12.191 0.836295C12.3564 0.787016 12.5238 0.876804 12.5733 1.04311L12.5741 1.04172Z"
          fill="#FFFFF2"
        />
      </svg>
      <p className={styles.textSticker}>Check-in Assessment</p>
    </div>
  );
}
